import React, { useEffect, useRef, useState, useContext } from "react";
import PanoramaContext from "./Context";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";

import { ReactComponent as ArrowLeftCircleSvg } from "../../../assets/newProject/arrow-left-circle-white.svg";
import { ReactComponent as ArrowRightCircleSvg } from "../../../assets/newProject/arrow-right-circle-white.svg";

import { ReactComponent as CloseSvg } from "../../../assets/auth/login-close.svg";
import useScreenSize from "../../../hooks/useScreenSize";

const assetsUri = import.meta.env.ASSETS_URI;

const SwapScene = () => {
  const {
    panoramas,
    selectedPanorama,
    materials,
    setSelectedPanorama,
    closeOverlay,
  } = useContext(PanoramaContext);
  const [init, setInit] = useState(undefined);
  const { screenSize } = useScreenSize();

  const handleSceneClick = (panoramaId) => {
    setSelectedPanorama(panoramaId);
    closeOverlay();
  };

  const handleCloseClick = () => {
    closeOverlay();
  };

  let _contentWidth = 300;

  if (panoramas.length >= 3) {
    _contentWidth = "100%";
  }

  if (panoramas.length == 2 && screenSize != "sm") {
    _contentWidth = "100%";
  }

  return (
    <div className="pannellum-swap-scene">
      <div className="pannellum-swap-scene-content">
        <div className="pannellum-swap-scene-header">
          <span className="pannellum-swap-scene-header__title">
            Select scene
          </span>
          <CloseSvg
            className="pannellum-swap-scene-header__close"
            height={15}
            onClick={handleCloseClick}
          />
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <ArrowLeftCircleSvg
            className="pannellum-swap-scene-content-list__arrow--left"
            width={48}
            style={{ cursor: "pointer", marginBottom: 35 + 25 + 12 }}
          />
          <Swiper
            className="pannellum-swap-scene-content-list"
            modules={[Autoplay, Navigation, Pagination]}
            spaceBetween={24}
            slidesPerView={1}
            autoplay={{
              delay: 5000,
              pauseOnMouseEnter: true,
            }}
            navigation={{
              enabled: true,
              prevEl: ".pannellum-swap-scene-content-list__arrow--left",
              nextEl: ".pannellum-swap-scene-content-list__arrow--right",
            }}
            speed={600}
            onInit={() => setInit(true)}
            loop={true}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: panoramas.length >= 2 ? 2 : panoramas.length,
              },
              1200: {
                slidesPerView: panoramas.length >= 3 ? 3 : panoramas.length,
              },
            }}
          >
            {panoramas.map((p, index) => {
              const classNames = ["pannellum-swap-scene-content-list-item"];

              if (selectedPanorama === p._id) {
                classNames.push(
                  "pannellum-swap-scene-content-list-item--selected"
                );
              }

              return (
                <SwiperSlide key={p._id}>
                  <div
                    className={classNames.join(" ")}
                    onClick={() => handleSceneClick(p._id)}
                  >
                    <img
                      className="pannellum-swap-scene-content-list-item__image"
                      alt="panorama"
                      src={`${assetsUri}/${p.banner ?? p.image}`}
                    />
                    <div
                      style={{
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      {p.name === "null" ? `Scene ${index + 1}` : p.name}
                      {selectedPanorama === p._id && (
                        <span className="pannellum-swap-scene-content-list-item__selected">
                          Current
                        </span>
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <ArrowRightCircleSvg
            className="pannellum-swap-scene-content-list__arrow--right"
            width={48}
            style={{ cursor: "pointer", marginBottom: 35 + 25 + 12 }}
          />
        </div>
      </div>
    </div>
  );
};

export default SwapScene;
